import { Component, Input, Output, EventEmitter, HostBinding, inject } from '@angular/core';
import {MatIcon} from "@angular/material/icon";
import {AuthenticationService} from '@modules/authentication';

@Component({
    selector: 'app-home-ludo-card-view',
    templateUrl: './app-home-ludo-card-view.component.html',
    imports: [
        MatIcon
    ],
    styleUrls: ['./app-home-ludo-card-view.component.scss']
})
export class AppHomeLudoCardViewComponent {
  private authenticationService = inject(AuthenticationService);
  private authService = this.authenticationService;

    @Input() dataCard: any;
    @Output() playLudoCard = new EventEmitter<any>();
    @Output() goToSearchLessons = new EventEmitter<any>();

    @HostBinding('class.js-home-ludo-card-view--learner')
        public get isLearnerClass(): boolean {
        return this.authenticationService.isLearner();
    }

    @HostBinding('class.js-home-ludo-card-view--parent')
        public get isParentClass(): boolean {
        return !this.authenticationService.isLearner() && this.authService.isParent();
    }

  public onPlayLudoCard(event: any) {
    this.playLudoCard.emit(event);
  }

  public onGoToSearchLessons(event: any) {
    this.goToSearchLessons.emit(event);
  }
}